import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { useSubscription } from "store/auth/auth-store";
import { ISowWorkerRoles } from "./@types";

const fetchSowWorkerRoles = async (type: "equipment" | "worker") => {
  const roles = await apiInputService.get(`/sowWorkerRole/type/${type}`);

  const { data } = roles;

  return data?.sort((a: ISowWorkerRoles, b: ISowWorkerRoles) =>
    a.name > b.name ? 1 : -1
  );
};

export const useSowWorkerRoles = (
  type: "equipment" | "worker",
  options?: any
) => {
  const { subscription } = useSubscription();

  return useQuery<ISowWorkerRoles[]>(
    ["sow", subscription?.subscriptionId, type],
    () => fetchSowWorkerRoles(type),
    {
      staleTime: Infinity,
      enabled: !!subscription?.subscriptionId,
      ...options,
    }
  );
};
